import { memo } from "react";
import { motion } from "framer-motion";

import { DIALOG_MODAL_ANIMATION_DURATION } from "./DialogModal";

export const DialogModalBackdrop = memo(function DialogModalBackdrop() {
  return (
    <motion.div
      className="DialogModalBackdrop"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: DIALOG_MODAL_ANIMATION_DURATION,
      }}
    />
  );
});
